module.exports = __webpack_public_path__ + "img/default_user.d1ed03da.jpg";